/* 
 * asyncify is a utility function to make any function async on the fly
 */
async function asyncify (f, params, delay = 0) {
    const p = new Promise((resolve) => {
        if (delay) {
           setTimeout(()=> {
            const r = f(params);
            resolve(r);
           }, delay);
           return;
        }
        const r = f(params);
        resolve(r);
    });
    const result = await p;
    return result;
}

export default asyncify;